import React from "react";
import MDInput from "materialDashboard/components/MDInput";
import {useTranslation} from "react-i18next";


const Elevation = ({elevation, setElevation, labelType = "lte", ...rest}) => {
    const {t} = useTranslation("inputs");

    const handleChange = (e) => {
        if (e.target.value === "") {
            setElevation(null);
        } else {
            const value = parseInt(e.target.value);
            if (!isNaN(value)) {
                setElevation(value);
            }
        }
    }

    const label = labelType === "gte" ? t("elevationGte.label") : t("elevationLte.label")

    return (
        <MDInput variant="standard"
                 label={label}
                 fullWidth
                 type="number"
                 value={elevation ?? ""}
                 onChange={handleChange}
                 {...rest}/>
    )

}

export default Elevation;